import {
  Box, Button, Card, CardContent, makeStyles, Typography,
} from '@material-ui/core';
import Warning from '@material-ui/icons/Warning';
import parse from 'html-react-parser';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  card: {
    margin: theme.spacing(2, 0, 4, 0),
    background: theme.palette.background.card,
    borderRadius: 15,
    padding: theme.spacing(0, 1),
  },
  cardText: {
    color: theme.palette.text.default,
    background: theme.palette.background.card,
    fontFamily: 'Raleway',
    fontSize: 14,
    padding: theme.spacing(0, 1),
  },
  cardTitle: {
    color: theme.palette.text.default,
    fontFamily: 'Raleway',
    margin: theme.spacing(2, 0),
  },
  input: {
    border: 'solid 1px',
    borderRadius: 5,
    display: 'flex',
    flexDirection: 'row',
    height: 50,
    padding: theme.spacing(0, 2),
    margin: theme.spacing(3, 0),
    alignItems: 'center',
    borderColor: theme.palette.common.white,
  },
  textInput: {
    color: theme.palette.text.default,
    fontFamily: 'Raleway',
    fontSize: 14,
  },
  button: {
    fontFamily: 'Raleway',
    textTransform: 'capitalize',
    background: theme.palette.background.grey,
    border: 'none',
    color: theme.palette.text.default,
    margin: theme.spacing(0, 2, 0, 0),
  },
  containerButtonSubmit: {
    textAlign: 'end',
  },
  sizeFile: {
    color: 'gray',
    margin: theme.spacing(0, 3),
  },
  btnFile: {
    '&:disabled': {
      background: theme.palette.common.gray,
    },
    '&:hover': {
      background: theme.palette.common.pinkLigth,
    },
  },
  btnClear: {
    background: theme.palette.background.secondary,
    color: 'white',
    margin: theme.spacing(0, 2),
    '&:disabled': {
      background: theme.palette.common.gray,
    },
    '&:hover': {
      background: theme.palette.common.pinkLigth,
    },
  },
  messageContain: {
    display: 'flex',
  },
  messageFile: {
    color: theme.palette.background.info,
    fontSize: '15px',
  },
  iconWarning: {
    color: theme.palette.background.info,
    fontSize: '18px',
    margin: theme.spacing(0, 2),
  },
}));
function PracticalCase({
  clearFile,
  file, changeInputValue,
  nameFile, uploadFileToS3, content, isFinalProject, fileSend, isLoading, sizeFile,
}) {
  const classes = useStyles();

  return (
    <Box>
      <Card className={classes.card}>
        <CardContent>
          <Typography className={classes.cardTitle}>
            {isFinalProject ? 'Proyecto Final' : 'Caso Práctico'}
          </Typography>
          <hr />
          <Typography className={classes.cardText}>
            {parse(content || '')}
          </Typography>
        </CardContent>
      </Card>
      <Box className={classes.input}>
        {file === '' ? (
          <>
            <Button
              className={classes.button}
              variant="contained"
              component="label"
              disabled={fileSend}
            >
              Elegir documento
              <input
                type="file"
                value={file}
                accept=".doc, .docx, .pdf, video/*"
                hidden
                onChange={changeInputValue}
              />
            </Button>
            <Typography className={classes.textInput}>
              {fileSend ? 'Archivo enviado' : 'Ningún archivo seleccionado'}
            </Typography>
          </>
        ) : (
          <>
            <Typography className={classes.textInput}>
              {nameFile}
              {' '}
            </Typography>
            <Typography className={classes.sizeFile}>
              {' '}
              {sizeFile.toFixed(2)}
              {' '}
              Mb
            </Typography>
          </>
        )}
      </Box>
      <Box className={classes.messageContain}>
        <Warning className={classes.iconWarning} />
        <Typography className={classes.messageFile}>
          {' '}
          Importante: El archivo debe ser en formato MP4, Word o PDF y con un
          peso máximo de 2MB.
          {' '}
        </Typography>
      </Box>
      <Box className={classes.containerButtonSubmit}>
        {file && (
          <Button
            variant="contained"
            className={classes.btnClear}
            onClick={clearFile}
          >
            Limpiar
          </Button>
        )}
        {!isLoading ? (
          <Button
            variant="contained"
            color="secondary"
            className={classes.btnFile}
            onClick={uploadFileToS3}
            disabled={((file === '') || (sizeFile > 2))}
          >
            Enviar
          </Button>
        ) : (
          <Button variant="contained" color="secondary">
            Cargando...
          </Button>
        )}
      </Box>
    </Box>
  );
}
export default PracticalCase;

PracticalCase.propTypes = {
  clearFile: PropTypes.func.isRequired,
  file: PropTypes.string.isRequired,
  changeInputValue: PropTypes.func.isRequired,
  nameFile: PropTypes.string.isRequired,
  uploadFileToS3: PropTypes.func.isRequired,
  content: PropTypes.string.isRequired,
  isFinalProject: PropTypes.bool.isRequired,
  fileSend: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  sizeFile: PropTypes.number.isRequired,
};
